import { Card, List, Space, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { EngagementEventItem } from '../../types/engagement.types';

const { Text } = Typography;

interface EngagementEventTimelineProps {
  events: EngagementEventItem[];
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

const formatDelta = (value: number) => (value > 0 ? `+${value}` : `${value}`);

export const EngagementEventTimeline = ({
  events,
  page,
  pageSize,
  total,
  onPageChange,
}: EngagementEventTimelineProps) => {
  return (
    <Card title="Histórico recente de pontos" style={{ marginBottom: 24 }}>
      <List
        dataSource={events}
        locale={{ emptyText: 'Nenhum evento de pontuação registrado neste ciclo.' }}
        pagination={{
          current: page,
          pageSize,
          total,
          onChange: onPageChange,
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
        renderItem={(item) => (
          <List.Item>
            <Space style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text>
                {item.description} - {dayjs(item.happenedAt).format('DD/MM/YYYY HH:mm')}
              </Text>
              <Tag color={item.pointsDelta >= 0 ? 'green' : 'red'}>{formatDelta(item.pointsDelta)} ponto(s)</Tag>
            </Space>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default EngagementEventTimeline;
